import { useFormContext } from "components/Form";
import { Controller } from "react-hook-form";
import {
  InputCurrency as InputCurrencyComponent,
  InputCurrencyProps,
} from "components/InputCurrency";

type Props = Omit<InputCurrencyProps, "value"> & {
  name: string;
};

export function InputCurrency({ ...rest }: Props) {
  const {
    methodsForm: { control },
  } = useFormContext();

  return (
    <Controller
      name={rest.name}
      control={control}
      defaultValue={0}
      render={({ field }) => {
        const { ref, value, onChange, ...fieldProps } = field;
        return (
          <InputCurrencyComponent
            {...rest}
            {...fieldProps}
            value={value ?? 0}
            onChange={(value) => onChange(value)}
            ref={ref}
          />
        );
      }}
    />
  );
}
